import { useLDClient } from '@launchdarkly/react-sdk';
import { legacyDashCaseObjectKeysToCamelCase } from 'integrations/launchDarkly/impl/backwardCompatibilityUtils';
import { useDarklyMock } from 'integrations/launchDarkly/legacy/useDarklyMock';
import { useEffect, useState } from 'react';
import { LaunchDarklyFeatureFlags } from './LaunchDarklyFeatureFlags.types';

const NO_FLAGS = {};

/**
 * @deprecated use import from "@oc/darkly/oc" instead
 */
export const useDarkly = (): LaunchDarklyFeatureFlags => {
  const client = useLDClient();
  const [flags, setFlags] = useState(() => {
    if (!client.isReady()) {
      return {} as LaunchDarklyFeatureFlags;
    }
    return legacyDashCaseObjectKeysToCamelCase<LaunchDarklyFeatureFlags>(client.allFlags() ?? {});
  });

  useEffect(() => {
    function updateFlags() {
      setFlags(legacyDashCaseObjectKeysToCamelCase<LaunchDarklyFeatureFlags>(client.allFlags() ?? {}));
    }
    if (!client.isReady()) {
      client.waitForInitialization().then((e) => {
        updateFlags();
      });
      return;
    }
    if (client) {
      client.on('change', updateFlags);
    }
    return () => {
      if (client) {
        client.off('change', updateFlags);
      }
    };
  }, [client]);

  const ocFlags = flags ?? NO_FLAGS;

  const mockedFlags = useDarklyMock();

  if (mockedFlags.enabled) {
    return mockedFlags.flags;
  }
  return ocFlags;
};
